import { HttpClient } from '@wix/http-client';
import {
  TEXT_ON_IMAGE_FLOWS,
  TextOnImageGetPhotoSceneParams,
  TextOnImageResponse,
} from '../types';
import { getRandomTemplateImageBySectionAndFlow } from './fetchDataUtils';
import { applyColorOverlayAndGetFile, reportTextOnImageError } from './utils';
import { PromptHubAcceptedUrls } from '../../chatController/sgChat/constants';
import {
  AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
  SG_FEATURE_NAME,
} from '../../consts';
import { RGB_PROMPT_IDS } from './consts';

const CONTROL_IMAGE_URL =
  'https://static.wixstatic.com/media/47a484_f0df4a0545e64bb296daa1441773269c~mv2.jpg';

export const getDataVisualizationImage = async (
  httpClient: HttpClient,
  sectionName: string,
  params: TextOnImageGetPhotoSceneParams,
  imageUploadHandlers: unknown,
): Promise<TextOnImageResponse | undefined> => {
  const { photoTheme, sectionId, brightness } = params;
  const rgb = await getTextOnImageRgbDataVisualizationFlow(httpClient, {
    photoTheme,
  });

  const templateImageFromCMS = await getRandomTemplateImageBySectionAndFlow(
    sectionName,
    TEXT_ON_IMAGE_FLOWS.DATA_VISUALIZATION,
    sectionId,
    params.brightness,
  );

  const controlImageUrl = templateImageFromCMS?.url || CONTROL_IMAGE_URL;
  const imageUrl = await applyColorOverlayAndGetFile(
    controlImageUrl,
    rgb,
    brightness,
  );
  return { imageUrl, controlImageUrl, photoScene: rgb };
};

export const getTextOnImageRgbDataVisualizationFlow = async (
  httpClient: HttpClient,
  params: { photoTheme: string },
): Promise<string> => {
  try {
    const { data } = await httpClient.post(
      PromptHubAcceptedUrls.AI_GATEWAY_URL,
      {
        appDefId: AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
        promptId: RGB_PROMPT_IDS[TEXT_ON_IMAGE_FLOWS.DATA_VISUALIZATION],
        params,
        userRequestInfo: {
          featureName: SG_FEATURE_NAME,
        },
      },
    );
    const { RGB } = JSON.parse(data.response.generatedTexts[0]);
    return RGB;
  } catch (error: any) {
    const errorResponse = error.response?.data;
    reportTextOnImageError(`Failed to get rgb: ${errorResponse}`);
    return '0,0,0';
  }
};
